query FileCabinetDocumentSearch(
  $isSigningSearch: Boolean
  $first: Int
  $after: Cursor
  $fileCabinetDocumentSearchRequest: SearchRequestInput
  $isLinkSearch: Boolean
  $orderBy: [EntityDocumentsOrderBy!]
  $filter: EntityDocumentFilter
  $filterCurrencyId:Int
  $filterDocumentTypeId: Int
  $filterFolderId: UUID
  $filterProcessHistoryId: [UUID]
  $isFilterUnprocessedDocuments: Boolean
  $filterBusinessUnitId:UUID
  $filterDepartmentId:UUID
) {
  fileCabinetDocumentSearch(
    isSigningSearch: $isSigningSearch
    isLinkSearch: $isLinkSearch
    searchRequest: $fileCabinetDocumentSearchRequest
    first: $first
    after: $after
    orderBy: $orderBy
    filter: $filter
    filterCurrencyId:$filterCurrencyId
    filterDocumentTypeId: $filterDocumentTypeId
    filterFolderId:$filterFolderId
    filterProcessHistoryId:$filterProcessHistoryId
    isFilterUnprocessedDocuments:$isFilterUnprocessedDocuments
    filterBusinessUnitId:$filterBusinessUnitId,
    filterDepartmentId:$filterDepartmentId
  ) {
    nodes {
      id
      _linkedInfo
      {
        businessUnitId
        businessUnitName
        departmentId
        departmentName
      }
      entityId
      _documentFileId
      _documentContents
      _isAccountingDocument
      entityDocumentTypeId
      comment
      currency {
        isoCode
      }
      _isProtected
      _documentPoolName
      indexAmount
      indexCurrencyId
      _exportDate
      _exportedByUser
      indexReferenceNumber
      indexTransactionDate
      _fileName
      _fileType
      _fileViewer
      _createdDate
      fileReference
      iconType
      entityDocumentSecureRowLevels {
        name
        securityLevel
      }
      _uploadDate
      _rowTimestamp
      _isSelected
      _documentType
      indexName
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
    }
  }
}
